import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FiHome, FiMap, FiMapPin, FiUsers, FiDollarSign, FiFileText, FiFile, FiMail, FiShuffle, FiSettings, FiLogOut, FiMenu, FiX, FiChevronDown, FiChevronRight, FiGlobe, FiSend, FiTrendingUp, FiUpload } from 'react-icons/fi';
import logoCohamac from '../assets/logo-COHAMAC.png';

const AdminLayout = () => {
  const { user, logout, isAdmin, isSuperAdmin } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [paramOpen, setParamOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const admin = isAdmin();
  const superAdmin = isSuperAdmin();

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src={logoCohamac} alt="COHAMAC" className="sidebar-logo-img" />
          <div className="sidebar-user">{user?.prenomnom || user?.prenom}</div>
          <div className="sidebar-role">{user?.role}</div>
        </div>

        <nav className="sidebar-nav">
          {admin ? (
            <>
              <NavLink to="/admin" end className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiHome /> <span>Dashboard</span>
              </NavLink>
              <NavLink to="/admin/projets" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiMap /> <span>Projets</span>
              </NavLink>
              <NavLink to="/admin/parcelles" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiMapPin /> <span>Parcelles</span>
              </NavLink>
              <NavLink to="/admin/membres" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiUsers /> <span>Membres</span>
              </NavLink>
              <NavLink to="/admin/versements" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiDollarSign /> <span>Versements</span>
              </NavLink>
              <NavLink to="/admin/chargements" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiUpload /> <span>Chargements</span>
              </NavLink>
              <NavLink to="/admin/charges" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiFileText /> <span>Dépenses / Charges</span>
              </NavLink>
              <NavLink to="/admin/documents" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiFile /> <span>Documents</span>
              </NavLink>
              <NavLink to="/admin/articles" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiFileText /> <span>Articles</span>
              </NavLink>
              <NavLink to="/admin/tirages" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiShuffle /> <span>Tirage</span>
              </NavLink>
              <NavLink to="/admin/cartographie" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiGlobe /> <span>Cartographie</span>
              </NavLink>
              <NavLink to="/admin/messagerie" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiSend /> <span>Messagerie</span>
              </NavLink>
              <NavLink to="/admin/statistiques" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiTrendingUp /> <span>Statistiques</span>
              </NavLink>

              {/* Administration section - superadmin only */}
              {superAdmin && (
                <>
                  <div className="sidebar-section">Administration</div>

                  <div className={`sidebar-submenu ${paramOpen ? 'open' : ''}`}>
                    <div className="sidebar-link" onClick={() => setParamOpen(!paramOpen)} style={{ cursor: 'pointer' }}>
                      <FiSettings /> <span>Paramétrage</span>
                      <span style={{ marginLeft: 'auto' }}>{paramOpen ? <FiChevronDown /> : <FiChevronRight />}</span>
                    </div>
                    {paramOpen && (
                      <div className="submenu-items">
                        <NavLink to="/admin/parametrage/typecharges" className={({ isActive }) => `sidebar-link sub ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                          <span>Types de charge</span>
                        </NavLink>
                        <NavLink to="/admin/parametrage/typepaiements" className={({ isActive }) => `sidebar-link sub ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                          <span>Types de versement</span>
                        </NavLink>
                        <NavLink to="/admin/parametrage/typedocuments" className={({ isActive }) => `sidebar-link sub ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                          <span>Types de document</span>
                        </NavLink>
                        <NavLink to="/admin/parametrage/etapes" className={({ isActive }) => `sidebar-link sub ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                          <span>Étapes</span>
                        </NavLink>
                        <NavLink to="/admin/parametrage/rubriques" className={({ isActive }) => `sidebar-link sub ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                          <span>Rubriques</span>
                        </NavLink>
                      </div>
                    )}
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <NavLink to="/admin" end className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiHome /> <span>Mon tableau de bord</span>
              </NavLink>
              <NavLink to="/admin/mes-parcelles" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiMapPin /> <span>Mes parcelles</span>
              </NavLink>
              <NavLink to="/admin/ma-cartographie" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiGlobe /> <span>Ma cartographie</span>
              </NavLink>
              <NavLink to="/admin/mes-versements" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiDollarSign /> <span>Mes versements</span>
              </NavLink>
              <NavLink to="/admin/mes-documents" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiFile /> <span>Mes documents</span>
              </NavLink>
              <NavLink to="/admin/profil" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
                <FiUsers /> <span>Mon profil</span>
              </NavLink>
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <NavLink to="/" className="sidebar-link site-link">
            <FiGlobe /> <span>Retour au site</span>
          </NavLink>
          <button className="sidebar-link logout-btn" onClick={handleLogout}>
            <FiLogOut /> <span>Déconnexion</span>
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="main-content">
        <header className="topbar">
          <button className="toggle-sidebar" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? <FiX /> : <FiMenu />}
          </button>
          <div className="topbar-right">
            <span className="topbar-user">{user?.prenomnom}</span>
            <button className="btn-logout-top" onClick={handleLogout}><FiLogOut /></button>
          </div>
        </header>
        <div className="page-content">
          <Outlet />
        </div>
      </div>

      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}
    </div>
  );
};

export default AdminLayout;
